import { render, staticRenderFns } from "./SelectRoles.vue?vue&type=template&id=3fbad084&scoped=true&"
import script from "./SelectRoles.vue?vue&type=script&lang=js&"
export * from "./SelectRoles.vue?vue&type=script&lang=js&"
import style0 from "./SelectRoles.vue?vue&type=style&index=0&id=3fbad084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbad084",
  null
  
)

export default component.exports